<template>
  <Layout header-class="header-left-align" nav-alignment="left">
    <div class="error-area ptb--200 ptb_sm--60 ptb_md--80">
      <div class="container">
        <div class="error-inner">
          <h1>404</h1>
          <h2 class="title">{{ $t('NotFound.title') }}</h2>
          <p class="description">{{ $t('NotFound.description') }}</p>
          <div class="view-more-button">
            <router-link class="btn-default" to="/">{{ $t('NotFound.backHome') }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/common/Layout'

export default {
  name: 'NotFound',
  components: { Layout }
}
</script>
